import { Suspense } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";

import { UsersDirectory } from "app/components/rbac/UsersDirectory";
import { TableSkeleton } from "app/components/skeletons";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { type UsersSettingsRootQuery } from "./__generated__/UsersSettingsRootQuery.graphql";
import { AccessControlSettingsPage } from "./AccessControlSettingsPage";
import { UsersActionBar } from "./UsersActionBar";

export function UsersSettingsRoot() {
  const data = useLazyLoadQuery<UsersSettingsRootQuery>(
    graphql`
      query UsersSettingsRootQuery {
        ...AccessControlSettingsPage_query
      }
    `,
    {},
  );

  return (
    <AccessControlSettingsPage pageTitle="Users" queryRef={data}>
      <SettingsTabsLayout>
        <div className="flex w-full flex-col">
          <UsersActionBar />

          <Suspense fallback={<TableSkeleton size="medium" />}>
            <UsersDirectory />
          </Suspense>
        </div>
      </SettingsTabsLayout>
    </AccessControlSettingsPage>
  );
}
